import axios from 'axios';
import { BaseHttpClient } from '../BaseHttpClient';
import { injectCommonInterceptors } from '../interceptors';
import { BASE_URL } from './consts';
import {
  DisconnectIntegrationRequest,
  GenerateOAuthStateRequest,
  GenerateOAuthStateResponse,
  IntegrationConnectionStatusResponse,
  ServiceNowConnectRequest,
  ServiceNowConnectResponse,
} from './types';

const axiosIntegrationsInstance = axios.create({
  baseURL: BASE_URL,
});

injectCommonInterceptors(axiosIntegrationsInstance);

export class IntegrationsClient extends BaseHttpClient {
  constructor() {
    super(axiosIntegrationsInstance, {
      defaultExtractNestedData: false,
    });
  }

  // Singleton instance for access without instantiation
  static override instance = new IntegrationsClient();

  static async getConnectionStatus(): Promise<IntegrationConnectionStatusResponse> {
    return await IntegrationsClient.get('/connection_status');
  }

  static async generateOAuthState(
    request: GenerateOAuthStateRequest,
  ): Promise<GenerateOAuthStateResponse> {
    return await IntegrationsClient.post('/oauth/state', request);
  }

  /** Disconnects all connections for the given provider in the current workspace. */
  static async disconnect(
    request: DisconnectIntegrationRequest,
  ): Promise<void> {
    await IntegrationsClient.post('/disconnect', request);
  }

  // ServiceNow uses Basic auth (a read-only service account), not OAuth, so it
  // POSTs creds directly instead of going through the OAuth redirect flow.
  static async connectServiceNow(
    request: ServiceNowConnectRequest,
  ): Promise<ServiceNowConnectResponse> {
    return await IntegrationsClient.post('/servicenow/connect', request);
  }
}
